import { Processing } from '@wg/wows-react-uikit';
import styles from './GachaBannerLoader.scss';

const GachaBannerLoader = () => {
    return (
        <div className={styles.loader}>
            <Processing isFetching />
        </div>
    );
};

export default GachaBannerLoader;
